const getters = {
    menuLists(state) {
        return state.menuLists;
    }
};

export default getters;